import { getElementClientRect } from '../helpers'
import { TModuleState, TPlacement, TRect } from '../types'

interface IShouldFlipProps {
    placement: TPlacement
    referenceRect: TRect
    popupRect: TRect
    offset: number
    scrollableParent: HTMLElement | Window
}

function getOpositePlacement(placement: TPlacement) {
    switch (placement) {
        case 'top-start':
            return 'bottom-start'
        case 'top':
            return 'bottom'
        case 'top-end':
            return 'bottom-end'
        case 'right-start':
            return 'left-start'
        case 'right':
            return 'left'
        case 'right-end':
            return 'left-end'
        case 'left-start':
            return 'right-start'
        case 'left':
            return 'right'
        case 'left-end':
            return 'right-end'
        case 'bottom-start':
            return 'top-start'
        case 'bottom':
            return 'top'
        case 'bottom-end':
            return 'top-end'
    }
}

function shouldFlip({ placement, offset, referenceRect, popupRect, scrollableParent }: IShouldFlipProps) {
    const scrollableParentRect = getElementClientRect(scrollableParent)
    const popupHeight = popupRect.height
    const referenceHeight = referenceRect.height
    const popupWidth = popupRect.width
    const referenceWidth = referenceRect.width
    /*
     * Calculate the top, right bottom, left of popup if it touch the limit
     * of scrollable parent
     * */
    const top = referenceRect.y - (popupHeight + offset)
    const bottom = referenceRect.y + referenceHeight + popupHeight + offset
    const left = referenceRect.x - popupWidth - offset
    const right = referenceRect.x + referenceWidth + popupWidth + offset
    switch (placement) {
        case 'top-start':
        case 'top':
        case 'top-end':
            return top < scrollableParentRect.top
        case 'bottom-start':
        case 'bottom':
        case 'bottom-end':
            return bottom > scrollableParentRect.bottom
        case 'left-start':
        case 'left':
        case 'left-end':
            return left < scrollableParentRect.left
        case 'right-start':
        case 'right':
        case 'right-end':
            return right > scrollableParentRect.right
    }
}

export default function flip({ reference, popup, scrollableParents, placement, popupConfigs }: TModuleState) {
    const { offset = 0, isFlip = true, useWindowAsFlippingContainer = false } = popupConfigs || {}
    /*
     * Return immediately if flip doesn't enable
     * */
    if (!isFlip || scrollableParents.size === 0) {
        return placement
    }
    let returnPlacement: TPlacement = placement
    let getScrollableParents = scrollableParents
    if (useWindowAsFlippingContainer) {
        getScrollableParents = new Set([window])
    }
    const referenceRect = reference.getBoundingClientRect()
    const popupRect = popup.getBoundingClientRect()
    getScrollableParents.forEach((scrollableParent) => {
        if (
            shouldFlip({
                placement,
                referenceRect,
                popupRect,
                offset,
                scrollableParent
            })
        ) {
            returnPlacement = getOpositePlacement(placement)
        }
    })
    return returnPlacement
}
